import { AmplitudeService } from '@/services/amplitudeService';
import { getAnalyticsUserProperties } from './getAnalyticsUserProperties';

export const setAllUserDataToAmplitudeProperty = (
	property?: Record<string, unknown>,
) => {
	const userProperty = getAnalyticsUserProperties();
	const merged = {
		...userProperty,
		...property,
	};

	AmplitudeService.setUserProperty(merged);
	// Reliable floor: also send via beacon so properties like utmCampaign land
	// even if the SDK's async $identify gets cancelled by a navigation.
	AmplitudeService.setUserPropertyViaBeacon(merged);
};
